<template>
    <v-dialog v-model="dialog" max-width="610" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">Create {{ is_teacher ? 'Teacher' : 'Student'}}</h2>

                    <ValidationProvider name="Name" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field label="Name"
                                      v-model="user.name"
                                      class="mt-5"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Surname" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field label="Surname"
                                      v-model="user.sur_name"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider vid="phone" name="Phone" :rules="{required : true, regex: /([0][1|3-9]{2})([0-9]{6})/, max: 9}" v-slot="{ errors }">
                        <v-text-field label="Phone"
                                      v-model="user.phone"
                                      maxlength="9"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-phone'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider vid="email" name="Email" rules="required|email" v-slot="{ errors }">
                        <v-text-field label="Email"
                                      type="email"
                                      v-model="user.email"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider name="Date of Birth" rules="required" v-slot="{ errors }">
                                <v-text-field :value="user.date_of_birth"
                                              label="Date of Birth"
                                              readonly
                                              v-bind="attrs"
                                              v-on="on"
                                >
                                    <template v-slot:prepend-inner>
                                        <svg v-svg="'icon-date'" size="15" class="mr-1"></svg>
                                    </template>
                                </v-text-field>
                                <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </template>

                        <v-date-picker :active-picker.sync="activePicker"
                                       v-model="user.date_of_birth"
                                       @change="$refs.menu.save($event)"
                                       :max="moment(new Date()).subtract(0, 'years').toISOString()"
                                       :min="moment(new Date()).subtract(60, 'years').toISOString()"
                                       color="green"
                        ></v-date-picker>
                    </v-menu>

                    <ValidationProvider name="Team" rules="required" v-slot="{ errors }" v-if="!is_teacher">
                        <v-select :items="TEAMS"
                                  label="Team"
                                  item-text="name"
                                  item-value="id"
                                  v-model="user.team_id"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-team'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingSave">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        props: ['is_teacher'],
        data(){
            return {
                menu: false,
                dialog: false,
                loadingSave: false,
                user: { is_teacher: this.is_teacher || false },
                activePicker: null,
            }
        },

        computed: mapGetters(['TEAMS']),

        watch: {
            menu (val) {
                val && setTimeout(() => (this.activePicker = 'YEAR'))
            }
        },

        methods: {
            save() {
                this.loadingSave = true;
                this.$apiAdmin('users').create(this.user)
                    .then(() => {
                        this.user = { is_teacher: this.is_teacher || false};
                        this.$refs.form.reset();
                        this.dialog = false;
                        this.$parent.getData();
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully created.'});
                    }).catch((err) => {
                    if (err.response.status === 422) this.$refs.form.setErrors(err.response.data);
                }).finally(() => {
                    this.loadingSave = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>